module.exports = "/images/headshot.png?3b27fb09f672aa8adefb95372fc5b0fa";